export default __webpack_public_path__ + "static/media/P-021.0937c44e.png";